import { PsCompany } from '../../../shared/model/company/PsCompany';

export class PsWorker {

    _id;
    _dni;
    _name;
    _lastName;
    _company; // PsCompany

    constructor(
        id,
        dni,
        name,
        lastName,
        state,
        company
    ) {
        this._id = id;
        this._dni = dni;
        this._name = name;
        this._lastName = lastName;
        this._state = state;
        this._company = company;
    }

    static fromBackendArray(workers) {
        return workers.map((w) => PsWorker.fromBackend(w));
    }

    static fromBackend(worker) {
        const workerCompany = PsCompany.fromAPICompany(worker.company);
        return new this(
            worker.id,
            worker.dni,
            worker.name,
            worker.last_name,
            worker.worker_state_id,
            workerCompany,
        );
    }

    id() {
        return this._id;
    }

    dni() {
        return this._dni;
    }

    name() {
        return this._name;
    }

    lastName() {
        return this._lastName;
    }

    completeName() {
        return `${this.name()} ${this.lastName()}`;
    }

    description() {
        return `${this.completeName()} (${this.dni()})`;
    }

    state() {
        return this._state;
    }

    company() {
        return this._company;
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/PsWorker.js